import { render, staticRenderFns } from "./avaliacoes.vue?vue&type=template&id=1b7efaa0"
import script from "./avaliacoes.vue?vue&type=script&lang=js"
export * from "./avaliacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports